import { FT, Scene } from 'ft'
import { Container, Sprite } from 'pixi.js'
import { timer } from 'ft/utils'
import Dialog from '#/components/Dialog'
import store from '#/store'
import bgm from '#/bgm'
import track from '#/track'
import Animation from './Animation'
import { default as Hero, heros } from './Hero'
import FreezeHero from './FreezeHero'
import DragHero from './DragHero'

const $soundSelect = 'sound.ui-select'
const $soundOK = 'sound.ui-ok'
const $bgSelector = 'porch-bg-selector'
const $selectTip = 'porch-select-tip'
const $buttonOK = 'share-ok'

const { rm } = FT
rm.addImage($bgSelector)
rm.addImage($buttonOK)
rm.addImage($selectTip)
rm.addSound($soundSelect)
rm.addSound($soundOK)

class Porch extends Scene {
  constructor(name) {
    super(name)

    track(`${store.type}-scene2`, `${store.type}-场景2`)

    this.animations = {}
    this.heros = []

    this.animations = new Animation()
    this.addChild(this.animations)

    this.render()
  }

  render = async () => {
    await timer.delay(1000)
    this.animations.knockDoor()

    await timer.delay(1000)
    const dialog = new Dialog(
      '咦，好像有人敲门，\n会是谁呢？',
      { align: 'left' },
      () => {
        this.removeChild(dialog)
        this.animations.hideKnockTip()
        this.showSelector()
      }
    )
    this.addChild(dialog)
  }

  showSelector() {
    const { rm } = FT

    const selector = new Container()
    this.selector = selector
    selector.interactive = true

    const bg = new Sprite(rm.texture($bgSelector))
    selector.addChild(bg)

    const tip = new Sprite(rm.texture($selectTip))
    tip.anchor.set(0.5)
    tip.x = FT.stage.centerX
    tip.y = 250
    selector.addChild(tip)

    const xOffset = 140
    const yOffset = 280
    heros.forEach((heroName, index) => {
      const hero = new Hero(heroName)
      this.heros.push(hero)

      let x = FT.stage.centerX
      let y = FT.stage.centerY
      if (index % 2 === 0) {
        x -= xOffset
      } else {
        x += xOffset
      }

      y += Math.floor(index / 2 - 1) * yOffset

      hero.position.set(x, y)
      selector.addChild(hero)
    })

    this.isHeroSelected = false
    selector.on('pointerup', ({ target }) => {
      const heroName = target.name
      if (heroName) {
        this.heros.forEach(hero => {
          hero.unselect()
        })
        target.select()
        rm.sound($soundSelect).play()
        store.hero = heroName
      }
    })

    const buttonOK = new Sprite(rm.texture($buttonOK))
    buttonOK.interactive = true
    buttonOK.anchor.set(0.5)
    buttonOK.x = FT.stage.centerX
    buttonOK.y = FT.stage.centerY + 480
    buttonOK.on('pointerup', () => {
      if (store.hero) {
        rm.sound($soundOK).play()

        track(`select-hero.${store.hero}`, '选择英雄')
        this.onHeroSelected()
      }
    })

    selector.addChild(buttonOK)

    this.addChild(selector)
  }

  hideSelector() {
    this.removeChild(this.selector)
  }

  onHeroSelected = async () => {
    this.hideSelector()

    await timer.delay(500)
    this.animations.openDoor()

    await timer.delay(500)
    const freezeHero = new FreezeHero(store.hero)
    this.addChild(freezeHero)
    freezeHero.play()
    bgm.playBedroom()

    await timer.delay(2500)
    const dialog = new Dialog(
      '啊！糟糕！\n总之赶紧让TA暖和起来！',
      { align: 'left' },
      async () => {
        const dragAnimation = new DragHero(store.hero)
        this.addChild(dragAnimation)
        await dragAnimation.play()
        this.nextScene()
      }
    )
    this.addChild(dialog)
  }

  nextScene = () => {
    FT.sm.load('bedroom', { transition: true })
  }
}

export default Porch
